// Utility to help run a single queue of "latest" async axios tasks and automatically cancel stale tasks
import axios, { CancelTokenSource } from 'axios';

export class SingleAxiosTaskManager {
  private taskId: number = 0;
  private taskCancelToken: CancelTokenSource | undefined;
  private onCancel?: (taskId: number) => void;
  private readonly getNextTaskId = () => this.taskId + 1;

  readonly cancelCurrentTask = () => {
    if (this.taskCancelToken) {
      this.taskCancelToken.cancel();
    }
    if (this.onCancel) {
      this.onCancel(this.taskId);
    }
  };
  readonly runNextTask = <T>(
    task: (taskId: number, taskCancelToken: CancelTokenSource) => T,
    options: { onCancel?: (taskId: number) => void } = {}
  ) => {
    this.cancelCurrentTask();
    this.taskCancelToken = axios.CancelToken.source();
    this.taskId = this.getNextTaskId();
    this.onCancel = options.onCancel;
    return task(this.taskId, this.taskCancelToken);
  };
}

export class MultiAxiosTaskManager {
  private taskManagers: { [key: string]: SingleAxiosTaskManager | undefined } = {};
  readonly runNextTask = <T>(
    key: string,
    task: (taskId: number, taskCancelToken: CancelTokenSource) => Promise<T>,
    options: { onCancel?: (taskId: number) => void } = {}
  ) => {
    if (!this.taskManagers[key]) {
      this.taskManagers[key] = new SingleAxiosTaskManager();
    }

    return this.taskManagers[key].runNextTask(task, options).then((args) => {
      this.taskManagers[key] = undefined;
      return args;
    });
  };
}
